import {
  Shield,
  Key,
  Brain,
  Link2,
  Users,
  TrendingUp,
  Zap,
  MessageSquare,
  PenTool,
} from "lucide-react";

export const pillars = [
  { icon: Shield, num: "01", title: "SEO Foundation Audit", desc: "Deep analysis of on-page elements, technical health, meta tags, and content quality to uncover what's holding your rankings back." },
  { icon: Key, num: "02", title: "Keyword Analysis", desc: "Comprehensive keyword density, placement, and intent analysis to ensure your content targets the right terms in the right places." },
  { icon: Brain, num: "03", title: "AI Visibility Engine", desc: "Measure how well your site surfaces in ChatGPT, Gemini, AI Overviews, and other AI-powered search experiences." },
  { icon: Link2, num: "04", title: "Backlink Intelligence", desc: "Evaluate your authority profile, toxic links, and domain trust signals that search engines use to rank your pages.", tier: "Starter" },
  { icon: Users, num: "05", title: "Competitor Intelligence", desc: "Side-by-side gap analysis reveals exactly where competitors outperform you — and how to close the gap.", tier: "Starter" },
  { icon: TrendingUp, num: "06", title: "Ranking Predictor", desc: "Data-driven estimation of your ranking potential based on current signals, content strength, and authority metrics." },
  { icon: Zap, num: "07", title: "Smart Action Plan", desc: "A prioritized, step-by-step roadmap of improvements sorted by impact — so you know exactly what to fix first.", tier: "Starter" },
];

export const comingSoonPillars = [
  { icon: MessageSquare, num: "08", title: "AI Agent Mode", desc: "Chat with an AI assistant directly within your analysis to get deeper insights, tailored suggestions, and step-by-step guidance.", premium: true },
  { icon: PenTool, num: "09", title: "Content Creation", desc: "Generate optimized titles, paragraphs, and content pieces based on your page data and keyword opportunities.", premium: true },
  { icon: Link2, num: "10", title: "Backlink Opportunities", desc: "Discover high-quality backlink prospects by analyzing your competitors' referring domains — find where they get links and how you can too.", premium: true },
];
